import * as React from "react";
import { Form, Input, Button } from "antd";
import { observer } from "mobx-react";
import { RouteComponentProps, withRouter } from "react-router";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "react-intl";
import { loginStore } from "../../models/LoginStore";
import LoginLayout from "../LoginLayout";
import {FormInstance} from "antd/lib/form";


const FormItem = Form.Item;
export type RegisterProps = RouteComponentProps<{ tab: string }> & InjectedIntlProps;

@observer
class EmailAccountVerification extends React.Component<RegisterProps, {}> {
    private readonly formRef: React.RefObject<FormInstance> = React.createRef();
    public constructor(props: RegisterProps) {
        super(props);
    }

    private handleSubmit = async (values: any): Promise<void> => {
        await loginStore.loginResetPassword(this.props.history, values.email);
    }

    public componentDidMount(): void {
        if (this.props.match.params.tab) {
            this.formRef.current!.setFieldsValue({email: this.props.match.params.tab});
        }
    }

    public render(): React.ReactNode {
        const {intl} = this.props;
        return (
            <LoginLayout>
                <div className="login-title">
                    <FormattedMessage
                        id={"email-verify.verify-account"}
                    />
                </div>
                <Form ref={this.formRef} onFinish={this.handleSubmit} className="login-form">
                    <FormItem
                        name={"email"}
                        rules={[
                            {
                                type: "email", message: intl.formatMessage({ id: "global.not-email-message" }),
                            },
                            { required: true, message: intl.formatMessage({ id: "email-verify.email-input" }) },
                        ]}
                    >
                        <Input
                            size={"large"}
                            onChange={evt => this.setState({ inputPhone: evt.target.value })}
                            placeholder={intl.formatMessage({ id: "email-verify.email-input" })} />
                    </FormItem>
                    <FormItem>
                        <div className="login-form-button-box">
                            <Button
                                type="primary"
                                size="large"
                                htmlType="submit"
                                loading={loginStore.resetPasswordLoadingState}
                                className="reset-password-form-button">
                                <FormattedMessage
                                    id={"email-verify.go-to-verification"}
                                />
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </LoginLayout>
        );
    }
}

export default withRouter(injectIntl(EmailAccountVerification));



// WEBPACK FOOTER //
// ./src/components/user/EmailAccountVerification.tsx